export { CommonGenericEvents, SectionParameters } from './analytics/analytics'

export const MENU_SERVICE_URL = '/ws-menu'
